// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";

class ExpenseList extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      date: params.get('date'),
      expense_data:[],
      expense_headers:[],
      loading: false
    };
    
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getExpense() {
    
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=5103&venue_id=${this.state.venue}&date=${this.state.date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({expense_data:data.data,expense_headers:data.headers})
           // alert("fix");
       }).catch(error => error);
  }

  renderExpenses(){
    var venue = this.state.venue;
    if(this.state.expense_data.length == 0 && this.state.expense_headers.length == 0){
      this.getExpense()
    }
    
    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Daily Expense</div> 
        <table className="table_plain">
          <tr> 
            {this.state.expense_headers.map((head)=>
              <th>{head}</th>
            )
          }
          </tr>
          
            { this.state.expense_data && this.state.expense_data.length > 0 ?
              this.state.expense_data.map((data)=>
                <tr>
                  { data.map((each)=>
                    <td dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.expense_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }
        </table>
      </div>
      )
  }

  render() {
    

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    
    console.log('props data',this.state.game_type)
    console.log('revenue_data',this.state.revenue_data)
    return(
      <div>
        
        <div>
        <div className="breadcrumps" style={{marginBottom:'2%'}}>
                        <a href={'/#/expenses'} >
                          <span>Expense</span>
                        </a> 
                        
                        <a>
                          <span> Daily Expense </span>
                        </a>  
          </div>
          {this.renderExpenses()}
        </div>
      </div>
    );
  }
}

export default ExpenseList;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/expenseList/ExpenseList.js